
















import { defineComponent } from "vue";

export default defineComponent({
  computed: {
    title() {
      switch (this.$route.name) {
        case "programa_saude_2.como_funciona":
          return "Como o programa funciona";
        case "programa_saude_2.boa_hora.agendamento":
          return "Agendamento";
        default:
          return "Programas de saúde";
      }
    },
    showFooter() {
      return this.$route.name !== "programa_saude_2.como_funciona";
    }
  },
  mounted() {
    this.$root.$emit("hide-loading");
  }
});
